import Table from "../../table/Table";
import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { Button, Card, Col, Modal, ModalHeader, ModalBody, ModalFooter, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { distributaryZoneTitle, Pages, Configuration } from "../../../constants";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";
import UploadSheet from "../../UploadExcelFile/UplooadSheet";
import AddIcon from "../../svg/AddIcon";
import DownloadExcel from "../../downloadExcel/DownloadExcel";
import Header from "../../../layout/header";
import LoadingComponent from "../../lodingComponent";
import { Filter } from "react-feather";

const BeneficiaryList = ()=>{
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const role = useAppSelector((state) => state.role.role);

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading
      } = usePagination({
        endpoint: `/beneficiarylist`,
        filterOn: 'SchemeVillage',
        enabled: true
      })
      const totalPages = Math.ceil(totalCount / pageSize);
    
      const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
      }, [setPageNumber, totalPages])
    
    
    
      const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
      }, [setPageNumber, totalPages])
    
      const handleDelete = (id: string) => {
        setSelectedId(id);
        setIsDeleteModalOpen(true);
      };

      const handleDeleteBeneficiary = async () => {
        try {
          const response = await ApiService.axiosApi(`/beneficiarylist/${selectedId}`, {
            method: 'DELETE',
          });
    
          if (response.success) {
            toast.success("Beneficiary deleted successfully");
            setIsDeleteModalOpen(false);
            setRefresh(prev => !prev);
          } else {
            toast.error(response.message);
          }
        } catch (error: any) {
          toast.error(error.message);
        }
      };
    
      const handleUpdate = (id: string) => {
        navigate(`/beneficiary-update/${id}`);
      };
    
     return(
          <>
             <Breadcrumbs mainTitle={"Beneficiary List"} parent={Configuration} />
      
        <Card>
          <CommonCardHeader title="Beneficiary List" headClass="pb-3" />
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: '10px' }} className='align-items-center flex-row d-flex'>
              <div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="...search"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value)
                    setPageNumber(1)
                  }}

                />
              </div>
              <div>
                <button className="filter-button mx-2 p-1" style={{ height: '30px' }} onClick={() => setSortBy('chackname')}>
                  <Filter/>
                </button>
              </div>

            </div>
            {role === "Administrator" && (
              <div className="d-flex justify-content-end">

                <Button onClick={() => navigate('/beneficiary-add')} size="md" color="primary" className="mb-2 mx-1 px-2"><div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
                  <AddIcon />
                </div>
                </Button>

              </div>
            )}
          </div>
          {loading ? <LoadingComponent/> :<Table
            data={data}
            columns={[
              {header:"ChakName", accessor: "chakName" },
              {header:"Scheme/Village", accessor: "schemeVillage" },
              {header:"Thasil",accessor:"thasil"},
              {header:"KhasaraNo",accessor:"khasaraNo"},
              {header:"PlotNo",accessor:"plotNo"},
              {header:"Kisam",accessor:"kisam"},
              {header:"CGA in [Ha]",accessor:"cgaInHa"},
              {header:"Uncultiv. Area",accessor:"unculArea"},
              {header:"Cultiv. Area",accessor:"culArea"},
              {header:"C.C.A Acre",accessor:"ccaAcre"},
              {header:"Name Of Beneficiary",accessor:"nameOfBeneficiary"}
            ]}
            buttons={[
              { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
              { label: "Delete", onClick: handleDelete, color: "danger", }
            ]}
          />}
          
          <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
          
              <p style={{ marginRight: '10px', marginTop: '8px' }}>
                   Page {pageNumber} of {totalPages}
             </p>
             
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
        </Card>
        <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
          <ModalHeader>Delete Beneficiary</ModalHeader>
          <ModalBody>Are you sure you want to delete this Beneficiary?</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDeleteBeneficiary}>Delete</Button>
            <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
          </ModalFooter>
        </Modal>
      
          </>
     )
}

export default BeneficiaryList;